import { NgModule } from '@angular/core';
import { EInvoiceSignUpComponent } from './e-invoice-sign-up.component';
import { AngularMaterialModule } from '../../angular-material.module';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { EInvoiceSignUpDialogComponent } from './e-invoice-sign-up-dialog/e-invoice-sign-up-dialog.component';
import { EInvoiceSignUpService } from './services/e-invoice-sign-up.service';
import { TranslateModule } from '@ngx-translate/core';
import { EInvoiceSignUpFormComponent } from './e-invoice-sign-up-form/e-invoice-sign-up-form.component';
import { ElementBlockerModule } from '../element-blocker/element-blocker.module';

@NgModule({
    imports: [
        AngularMaterialModule,
        CommonModule,
        ElementBlockerModule,
        ReactiveFormsModule,
        TranslateModule,
    ],
    declarations: [
        EInvoiceSignUpComponent,
        EInvoiceSignUpDialogComponent,
        EInvoiceSignUpFormComponent,
    ],
    providers: [EInvoiceSignUpService],
    exports: [
        EInvoiceSignUpComponent,
        EInvoiceSignUpDialogComponent,
    ]
})
export class EInvoiceSignUpModule {}
